module.exports = __webpack_public_path__ + "img/icon3.edc8f0d7.png";